import FamilleI18n from './Famille.i18n.js';
import {
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex'
export default {

  components: {},
  computed: {
    ...mapGetters(['familles', 'articlesLoading', 'articles', 'cart']),
    /**
     *  Computed to get his category name.
     */
    getFamilyName() {
      let family
      if (this.familles.length > 0) {
        this.familles.forEach(aFam => {
          if (aFam.id == this.$route.params.famId) {
            family = aFam
          }
        })
        if (family) {
          return family.nom
        } else {
          return ""
        }
      } else {
        return ""
      }
    },
  },
  props: {},

  data() {
    return {};
  },

  watch: {},

  methods: {
    ...mapMutations(['addToCart']),
    ...mapActions(['getFamilles', 'getArticlesActifs']),
    /**
     * Load products
     */
    loadProducts() {
      const info = {
        catId: this.$route.params.catId,
        famId: this.$route.params.famId
      }
      this.getArticlesActifs(info).then(res => {}).catch(err => {
        console.log(err)
      })
    },
    /**
     * Go to product page.
     * @param {*} pProd 
     */
    goToProduct(pProd) {
      // Not implemented yet.
    },
    /**
     * Got to product page.
     * @param {*} pProduct
     */
    goToProduct(pProduct) {
      const catId = this.$route.params.catId
      const famId = this.$route.params.famId
      const prodId = pProduct.id
      this.$router.push({
        path: `/categorie/${catId}/famille/${famId}/produit/${prodId}`
      })
    },
    getPhotoLink(pPhotoLink) {
      return pPhotoLink + '?cacheKey=' + Date.now()
    },
    prixCalcule(pArticle) {
      return pArticle.prix * (1 - pArticle.reduction / 100).toFixed(2)
    }
  },

  filters: {
    currency: (value) => {
      const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    }
  },

  mounted() {
    if (this.familles.length === 0) {
      this.getFamilles(this.$route.params.catId).then(res => {}).catch(err => {
        console.log(err)
      })
    }
    this.loadProducts()
  },

  i18n: FamilleI18n,

};